export enum actionTypes {
  DELETE_PARENT = 'Parent Sil',
  VIEW = 'İncele',
  ADDENDUM = 'Zeyil Talebi',
  CANCEL = 'İptal Talebi',
  DELETE = 'Sil',
  CHANGE = 'Düzenle',
  ADDITIONAL_FILE = 'Ek Dosya',
}

export enum modalTypes {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  CANCEL = 'CANCEL',
  ADDENDUM = 'ADDENDUM',
}

export enum StatusEnum {
  REQUEST_CREATED = 'request_created',
  CANCEL_EXPECTED = 'cancel_expected',
}

export enum DependentTypeEnum {
  'spouse' = 'Eş',
  'child' = 'Çocuk',
}
